import request from '@/plugin/axios'

export function getAdvertmentList (pageable) {
  return request({
    url: '/api/admin/ad',
    method: 'get',
    params: pageable
  })
}

export function createAdvertment (advert) {
  return request({
    url: '/api/admin/ad',
    method: 'post',
    data: advert
  })
}
export function updateAdvertment (advert) {
  return request({
    url: '/api/admin/ad/' + advert.id,
    method: 'put',
    data: advert
  })
}
export function deleteAdvertment (id) {
  return request({
    url: '/api/admin/ad/' + id,
    method: 'delete'
  })
}
export function checkAdvertCanModify (data) {
  return request({
    url: '/api/admin/checkAdvertCanModify',
    method: 'get',
    params: data
  })
}
export function queryDefaultAdvertmentList (pageable) {
  return request({
    url: '/api/admin/queryDefaultAdvert',
    method: 'get',
    params: pageable
  })
}

export function createDefaultAdvertment (advert) {
  return request({
    url: '/api/admin/storeDefaultAdvert',
    method: 'post',
    data: advert
  })
}
export function updateDefaultAdvertment (advert) {
  return request({
    url: '/api/admin/updateDefaultAdvert',
    method: 'post',
    data: advert
  })
}
export function queryShopAdvert (pageable) {
  return request({
    url: '/api/admin/queryShopAdvert',
    method: 'get',
    params: pageable
  })
}
export function addShopAdvert (data) {
  return request({
    url: '/api/admin/addShopAdvert',
    method: 'post',
    data: data
  })
}
export function updateShopAdvert (data) {
  return request({
    url: '/api/admin/updateShopAdvert',
    method: 'post',
    data: data
  })
}
export function deleteShopAdvert (data) {
  return request({
    url: '/api/admin/deleteShopAdvert',
    method: 'post',
    data: data
  })
}
